import { render, staticRenderFns } from "./RouteListDispatchedPage.vue?vue&type=template&id=512589e0&scoped=true&"
import script from "./RouteListDispatchedPage.vue?vue&type=script&lang=js&"
export * from "./RouteListDispatchedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512589e0",
  null
  
)

export default component.exports